import styled from "styled-components";

export const ProfileWrapper = styled.div`
  .content-head {
    background-color: var(--white);
    border-bottom: 1px solid var(--borderLight);
  }
  .optionsContent {
    margin-left: 50px;
  }
  .typeRadioBtnWrapper {
    margin-top: 50px;
    border-bottom: 1px solid var(--borderLight);
    padding-bottom: 30px;
  }
`;
export const FormDataContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  .separation-border {
    border-bottom: 1px solid var(--border);
  }
  .profileContent {
    display: block;
    width: 100%;
    flex-wrap: wrap;
    border-left: 1px solid var(--borderLight); // For LTR, apply left border
    .profileContentData {
      display: block;
      width: 100%;
      padding: 24px 30px 24px 30px;
    }
    body.rtl & {
      border-right: 1px solid var(--borderLight); /* For RTL */
      border-left: none; /* Disable left border for RTL */
    }

    .profileAvatarContainer {
      display: flex;
      width: 100%;
      height: fit-content;
      padding: 24px 30px 24px 30px;
      border-bottom: 1px solid var(--borderLight);
    }
  }
  .profileAvatarImg {
    position: relative;
    display: flex;
    width: 100%;
    align-items: center;
    .profileAvatarImgContainer {
      width: fit-content;
      position: relative;
    }
    .profileAvatar {
      display: block;
      width: 110px;
      height: 110px;
      border-radius: 50%;
    }
    .profileCamera {
      position: absolute;
      background-color: var(--themeColor2);
      border: 2px solid var(--white);
      border-radius: 50%;
      height: 40px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 4px;
      right: -12px;
      svg {
        margin-top: -2px;
      }
      body.rtl & {
        right: unset;
        left: -12px;
      }
    }
    .profileUserNameWrapper {
      padding-left: 25px;
      body.rtl & {
        padding-left: 0;
        padding-right: 25px;
      }
    }
  }
  .radiosContainer {
    display: flex;
    width: 100%;
    gap: 16px;
    flex-wrap: wrap;
  }
`;

export const ProfileSidebarWrapper = styled.div`
  width: 270px;
  height: 100%;
  z-index: 100;
  transition: 0.3s all;
  li {
    &:hover a,
    &.active a {
      background-color: var(--bgSecondary);
      &::before {
        opacity: 1;
      }
      svg {
        [stroke] {
          stroke: var(--themeColor);
        }
        [fill] {
          fill: var(--themeColor);
        }
      }
      span {
        color: var(--themeColor);
        font-weight: 600;
      }
    }
  }
  a {
    position: relative;
    padding: 10px 10px;
    transition: all ease-in-out 0.3s;
    font-size: 15px;
    color: var(--text);
    border-color: var(--themeColor2);
    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 0.25rem;
      background-color: var(--themeColor2);
      transition: all 0.3s ease;
      opacity: 0;
    }
    svg {
      width: 24px;
    }
    /* &:hover,
    &.active {
      background-color: var(--bgSecondary);
      &::before {
        opacity: 1;
      }
      svg {
        [stroke] {
          stroke: var(--themeColor);
        }
        [fill] {
          fill: var(--themeColor);
        }
      }
      span {
        color: var(--themeColor);
        font-weight: 600;
      }
    } */
  }

  .sidebar-list {
    height: calc(100vh - 86px);
    overflow-y: auto;
  }
`;

export const FormRadioWrapper = styled.label`
  display: flex;
  align-items: ${({ sublabel }) => !sublabel && "center"};
  gap: 15px;
  width: 100%;
  padding: 11px 15px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: var(--white);
  .radio-input:checked & .radio-label {
    span {
      color: var(--themeColor2);
    }
    color: var(--themeColor2);
  }
  .radio-input {
    appearance: none;
    min-width: 25px;
    max-width: 25px;
    height: 25px;
    border: 2px solid var(--border);
    background-color: var(--bgSecondary);
    border-radius: 50%;
    position: relative;

    &:checked {
      border: 7px solid var(--themeColor2);
      color: var(--themeColor2);
    }

    &:checked::after {
      content: "";
      width: 9px;
      height: 9px;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &:checked + div .radio-label {
      color: var(--themeColor2);
      font-weight: 900;
    }
  }
  &.archiveRadios {
    min-width: 135px;
    max-width: fit-content;
    border: 1px solid var(--borderLight);
  }
  @media (max-width: 530px) {
    padding: 5px;
  }
  /* .radio-text {
    font-weight: ${(props) => (props.checked ? "bold" : "normal")};
    color: ${(props) => (props.checked ? "var(--themeColor2)" : "var(--text)")};
  } */
`;

export const DatepickerWrapper = styled.div`
  width: 100%;
  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker-wrapper .form-control {
    background-color: ${({ bg }) => (bg ? bg : "var(--white)")};
    border: ${({ border }) => (border ? "none": "1px solid var(--borderLight)")};
    height: 48px;
    box-shadow: none;
    outline: none;
    border-radius: 10px;
    color: var(--text);
    font-size: 14px;
    &::placeholder {
      color: var(--text2);
    }
  }

  .react-datepicker__input-container {
    display: flex;
    align-items: center;
  }

  .react-datepicker__calendar-icon {
    width: 18px;
    height: 19px;
    padding-top: 5px;
  }

  .react-datepicker__view-calendar-icon input {
    padding: 6px 10px 5px 33px;
    body.rtl & {
      padding: 6px 33px 5px 10px;
    }
  }

  .form-control:focus {
    box-shadow: none;
    outline: none;
  }
`;